import {
  AppMultiSelect,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import errorHandler from '@/layout/components/error/ErrorHandler';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useDispatch } from 'react-redux';
import { axiosPath } from '../../../../routing/helpers/router';
import Translator from '../../helpers/Translator';
import useIsMounted from '../../hooks/useIsMounted';

/*
 * Types: all (ALL worldlex plants), client (default), module, userPlants, plants
 * IDs: Array of IDs of selected type (if apply). ClientIDs for client,
 * ModuleBridgeID for module, UserID for userPlants, PlantIDs for plants
 */
export default function PlantSelect(props) {
  const {
    value,
    onChange,
    type = 'client',
    format = 'module',
    isMulti = true,
    IDs = [],
    title = undefined,
    error = undefined,
  } = props;
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [options, setOptions] = useState([]);

  // > LOAD MODULES //
  const loadModules = useCallback(
    async () =>
      axios
        .post(axiosPath('api_r_user_global_select_plants'), {
          type,
          IDs,
          format,
        })
        .then((r) => {
          if (isMounted.current) {
            setOptions(r.data);
          }
        })
        .catch((e) => dispatch(errorHandler(e))),

    [type, IDs, format]
  );

  useEffect(() => {
    setOptions(null);
    loadModules();
  }, [IDs]);
  // < LOAD MODULES //

  if (isMulti) {
    return (
      <AppMultiSelect
        icon={<AppRemixIcon icon="globe" />}
        options={options}
        title={
          title ||
          ReactDOMServer.renderToString(
            <Translator file="user" name="user.plants" />
          )
        }
        placeholder={ReactDOMServer.renderToString(
          <Translator
            file="user"
            name="select.one.or.multiple.plants"
          />
        )}
        value={value}
        onChange={(opt) => onChange(opt)}
        allowSelectAll
        isLoading={!options}
        hasSearchBox
        hasSelectOptions
        error={error}
      />
    );
  }

  return (
    <AppSingleSelect
      icon={<AppRemixIcon icon="globe" />}
      options={options}
      title={
        title ||
        ReactDOMServer.renderToString(
          <Translator file="admin" name="general.installation" />
        )
      }
      placeholder={ReactDOMServer.renderToString(
        <Translator file="admin" name="client.plant.select-a-installations" />
      )}
      value={value}
      onChange={(opt) => onChange(opt)}
      isLoading={!options}
      hasSearchBox
      error={error}
    />
  );
}
